export default __webpack_public_path__ + "static/media/icon_facility_escalator.941cef00.svg";